<template>
    <!-- Company Set Up Page -->
    <div class="page-layout blank contacts-manage company-create">
        <div class="row" v-if="ajaxCallinprogress">
            <div class="col-lg-12 py-5 px-3 mt-10">
                <div class="flex-container">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                </div>
            </div>
        </div>
        <div class="pb-10" v-else>
            <div class="breadcrumbnew">
                <router-link to="/managecompany">List View</router-link>
                <span>Create Company</span>
            </div>
            <div class="page-layout carded bordertransparent left-sidebar" style="overflow-y: visible;">
                <div class="page-content-wrapper" style="border-radius: 15px;">
                    <div class="page-content custom-scrollbar" style="border-radius: 15px;">
                        <div class="row">
                            <div class="col-lg-12 p-0">
                                <div class="w-100">
                                    <div class="page-layout carded" style="background-color: #d6e2ef !important;">
                                        <div class="cover-pic-create-company row ml-0 mr-0">
                                            <img :src="company_details.cover_pic" class="h-100 w-100" />
                                            <div class="mt-2 fs-14 pl-3 pt-1 pointer custom-background-upload">
                                                <label
                                                    class="icon icon-picture text-white d-block fs-14 pr-1 w-100 pointer">
                                                    <input type="file" ref="myCompanyCoverpic"
                                                        accept="image/x-png, image/gif, image/jpeg"
                                                        @change="onCompanyBackground" />
                                                    <span class="ml-3 text-white font-weight-bold"
                                                        style="font-family: 'Poppins', sans-serif !important;">
                                                        Change
                                                        Picture
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="d-block companyPic">
                                            <img class="avatar huge bg-dark" :src="company_details.logo" />
                                            <label class="companyPicEdit">
                                                <input type="file" ref="myCompanyProfilepic"
                                                    accept="image/x-png, image/gif, image/jpeg"
                                                    @change="onCompanyProfile" />
                                                <img
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/editIcon.svg" />
                                            </label>
                                        </div>
                                        <div class="row mx-4 mb-15">
                                            <div class="col-lg-12 col-md-12 col-sm-12 mt-5 col-xs-12 formPadding">
                                                <form autocomplete="off">
                                                    <input autocomplete="off" name="hidden" type="text"
                                                        style="display:none;" />
                                                    <div class="block-company mt-4">
                                                        <div class="infoHeaderHideShow mt-3 mb-3" @click="expandInfo()">
                                                            <div class="descriptionheaderSetup"
                                                                style="background: transparent">
                                                                <div class="description-text-header-left"
                                                                    style="color: #303031">
                                                                    <h5 class="font-weight-bold text-dark whiteSpace">
                                                                        Company Information</h5>
                                                                </div>
                                                                <div class="description-text-header-right">
                                                                    <span class="collapse-addon"
                                                                        @click="expandInfo()"></span>
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hideShow.svg"
                                                                        :class="{'iconRotate':showInfo == true}"
                                                                        style="width: 23px !important;bottom:12px !important"
                                                                        class="rotateIcon" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="showInfo == true">
                                                            <div class="row">
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                    <div class="form-group">
                                                                        <input class="inputFieldNew new-text-box"
                                                                            name="company_name" type="text"
                                                                            @input="companyNameExists = false"
                                                                            @blur="checkCompanyName"
                                                                            v-model="company_details.company_name"
                                                                            v-validate="'required'"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as="Company Name"
                                                                            placeholder="Enter Company Name"
                                                                            :maxlength="maxlengthcompanyname"
                                                                            oninput="this.value = this.value.toUpperCase()" />
                                                                        <span class="inputBorder"></span>
                                                                        <label
                                                                            class="inputLabel text-secondary fs-14 fw-600">
                                                                            Company Name
                                                                            <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                        </label>
                                                                        <span
                                                                            class="character-count-dark">{{maxlengthcompanyname - company_details.company_name.length}}/100</span>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('companyData.company_name')">
                                                                            Company
                                                                            Name Is Required
                                                                        </span>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-if="companyNameExists">
                                                                            Company Name
                                                                            Already Exists!!
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                    <div class="pt-1">
                                                                        <span
                                                                            class="text-secondary whiteSpace fs-14 fw-600">
                                                                            Domain Name
                                                                            <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                        </span>
                                                                        <!-- v-validate="{required:true,regex: /^[a-z]+(?:-?[a-z\d])+\.[a-z]{2,6}$/}" -->
                                                                        <input-tag
                                                                            class="digi-input-tags-transparent digi-input-tag"
                                                                            v-model="company_details.company_domain"
                                                                            :addTagOnBlur="true"
                                                                            v-on:blur="getDomainNames()"
                                                                            name="company_domain"
                                                                            data-vv-as="Domain Name"
                                                                            v-validate="{required:true,regex:/^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/}"
                                                                            data-vv-scope="companyData"
                                                                            :placeholder="company_details.company_domain.length === 0 ? 'Enter Domain Name' : ''"
                                                                            style="border-radius:5px !important">
                                                                        </input-tag>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            v-if="domainIncorrect">Please Add Valid URL
                                                                            (Ex: digicollect.com,
                                                                            acoinvestment.com)</span>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            v-if="!domainValid">
                                                                            Domain Name
                                                                            Already Exists
                                                                        </span>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('companyData.company_domain')">Domain
                                                                            Name Is Required</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-6 col-md-6 col-sm-12"
                                                                    style="margin-top:17px">
                                                                    <div class="pt-1">
                                                                        <span
                                                                            class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                            Industry Type
                                                                            <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                        </span>
                                                                        <multiselect
                                                                            class="diginew-multiselect digicompany-multiselect digidark-multiselect loaderdark no-default-icon down-arrow comanyTimeSelect"
                                                                            placeholder="Select Industry Type"
                                                                            :clearable="false" :filterable="true"
                                                                            :options="companytype" @open="getIndustries"
                                                                            :loading="isLoading.industry_type"
                                                                            style="width: 100%;margin-top: 7px;"
                                                                            data-vv-scope="companyData"
                                                                            v-validate="'required'"
                                                                            v-model="company_details.company_type"
                                                                            data-vv-as="Industry Type"
                                                                            name="company_type">
                                                                            <template slot="noOptions">
                                                                                <div class="text-secondary text-center fw-600">No Industry Type Found</div>
                                                                            </template>
                                                                            <template slot="noResult">
                                                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                                                            </template>
                                                                        </multiselect>
                                                                        <span class="inputBorder"></span>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('companyData.company_type')">
                                                                            Industry
                                                                            Type Is Required
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5 pl-1">
                                                                    <div class="form-group pt-0">
                                                                        <span
                                                                            class="fs-14 text-secondary pl-3 fw-600 fs-14">Date
                                                                            of Incorporation(dd/mm/yyyy)</span>
                                                                        <date-picker :not-after="new Date()"
                                                                            name="date_of_incorporation"
                                                                            class="dateborderTransparent new-date mx-left calendar-edit-per pl-3"
                                                                            format="DD/MM/YYYY"
                                                                            placeholder="Select Date"
                                                                            v-model="company_details.date_of_incorporation"
                                                                            data-vv-as="Date Of Incorporation" lang="en"
                                                                            :clearable="false" :editable="false" confirm
                                                                            confirm-text="APPLY"
                                                                            data-vv-scope="companyData"></date-picker>
                                                                        <span
                                                                            class="invalid-feedback-form text-danger pl-3"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('companyData.date_of_incorporation')">
                                                                            Date
                                                                            of Incorporation Is
                                                                            Required
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                    <div class="pt-2">
                                                                        <span
                                                                            class="text-secondary whiteSpace vselectLabel fw-600 fs-14">Number
                                                                            of Employees</span>
                                                                        <v-select
                                                                            class="vselect-custom newborder new-select"
                                                                            v-model="company_details.number_of_employees"
                                                                            placeholder="Select Number of Employees"
                                                                            :clearable="false" :filterable="true"
                                                                            name="number_of_employees"
                                                                            data-vv-as="Number of Employees"
                                                                            data-vv-scope="companyData"
                                                                            :options="['1 - 4', '5 - 9', '10 - 19', '20 - 49', '50 - 99', '100 - 249', '250 - 499', '500 - 999', '1,000 +']"
                                                                            style="width: 100%;margin-top: 7px;">
                                                                        </v-select>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('companyData.number_of_employees')">{{errors.first('companyData.number_of_employees')}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                    <div class="pt-2">
                                                                        <span
                                                                            class="text-secondary whiteSpace vselectLabel fw-600 fs-14">
                                                                            Time Zone
                                                                            <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                        </span>
                                                                        <multiselect
                                                                            class="diginew-multiselect no-default-icon digicompany-multiselect digidark-multiselect loaderdark down-arrow comanyTimeSelect"
                                                                            placeholder="Select System Time Zone"
                                                                            :clearable="false" :filterable="true"
                                                                            :options="timezone"
                                                                            style="width: 100%;margin-top: 7px;"
                                                                            data-vv-scope="companyData"
                                                                            v-validate="'required'" v-model="timeZone"
                                                                            data-vv-as="Time Zone" name="time_zone"
                                                                            index="value" label="label">
                                                                            <template slot="noOptions">
                                                                                <div class="text-secondary text-center fw-600">No Time Zoon Found</div>
                                                                            </template>
                                                                            <template slot="noResult">
                                                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                                                            </template>
                                                                        </multiselect>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('companyData.time_zone')">{{errors.first('companyData.time_zone')}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                    <div class="form-group">
                                                                        <input class="inputFieldNew new-text-box"
                                                                            name="tax_id" data-vv-scope="companyData"
                                                                            data-vv-as="Tax Id"
                                                                            v-model="company_details.tax_id" type="text"
                                                                            placeholder="Enter Tax ID"
                                                                            v-validate="'required'" />
                                                                        <span class="inputBorder"></span>
                                                                        <label
                                                                            class="inputLabel text-secondary fs-14 fw-600">
                                                                            Tax ID
                                                                            <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                        </label>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            v-show="errors.has('companyData.tax_id')">Tax
                                                                            Id Is Required</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                    <div class="pt-2">
                                                                        <span
                                                                            class="text-secondary whiteSpace vselectLabel fw-600 fs-14">
                                                                            Currency
                                                                            <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                        </span>
                                                                        <multiselect
                                                                            class="diginew-multiselect digicompany-multiselect digidark-multiselect no-default-icon loaderdark down-arrow comanyTimeSelect"
                                                                            placeholder="Select Currency"
                                                                            :clearable="false" :filterable="true"
                                                                            :options="currency"
                                                                            style="width: 100%;margin-top: 7px;"
                                                                            data-vv-scope="companyData"
                                                                            v-validate="'required'"
                                                                            v-model="company_details.currency"
                                                                            data-vv-as="Currency" name="currency"
                                                                            label="label">
                                                                            <template slot="noOptions">
                                                                                <div class="text-secondary text-center fw-600">Currency Not Found</div>
                                                                            </template>
                                                                            <template slot="noResult">
                                                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                                                            </template>
                                                                        </multiselect>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('companyData.currency')">Currency
                                                                            Is Required</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
                                                                    <div class>
                                                                        <span
                                                                            class="text-secondary whiteSpace fw-600">About</span>
                                                                        <textarea-autosize
                                                                            class="digi-textarea digi-textarea-comapny"
                                                                            placeholder="Enter Text Here"
                                                                            v-model="company_details.about"
                                                                            :min-height="minHeight"
                                                                            :max-height="maxHeight"
                                                                            :maxlength="maxlengthcompanyabout"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as="About" name="about_company"
                                                                            style="border-radius: 5px;padding: 10px 10px 5px 15px !important;font-size: 14px !important;margin-top: 10px;border:solid 1px #676767 !important;" />
                                                                        <span
                                                                            class="character-count-dark">{{maxlengthcompanyabout - company_details.about.length}}/{{maxlengthcompanyabout}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="block-company mt-4">
                                                        <div class="infoHeaderHideShow mt-3 mb-3"
                                                            @click="expandContactInfo()">
                                                            <div class="descriptionheaderSetup"
                                                                style="background: transparent">
                                                                <div class="description-text-header-left"
                                                                    style="color: #303031">
                                                                    <h5 class="font-weight-bold text-dark whiteSpace">
                                                                        Contact Information</h5>
                                                                </div>
                                                                <div class="description-text-header-right">
                                                                    <span class="collapse-addon"
                                                                        @click="expandContactInfo()"></span>
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hideShow.svg"
                                                                        :class="{'iconRotate':showContactInfo == true}"
                                                                        style="width: 23px !important;bottom:12px !important"
                                                                        class="rotateIcon" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="showContactInfo == true">
                                                            <div class="row mx-0 d-flex align-items-center">
                                                                <input type="checkbox" v-model="publicDomain"
                                                                    @change="allowpublicdomain" />
                                                                <span
                                                                    class="text-secondary whiteSpace fw-600 fs-14 ml-2">Allow
                                                                    Public Domain</span>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-7">
                                                                    <span
                                                                        class="text-secondary whiteSpace fw-600 fs-14">Primary
                                                                        Email</span>
                                                                    <div class="email input-group mt-2">
                                                                        <input type="text"
                                                                            class="form-control-email-dropdown"
                                                                            v-model="selected_company_domain"
                                                                            @blur="checkPrimaryEmail"
                                                                            name="primary_email"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as="CompanyPrimary Email"
                                                                            v-validate="{regex: /^[a-zA-Z0-9-_.]+$/}"
                                                                            autocomplete="off"
                                                                            placeholder="Enter Primary Email" />
                                                                        <span class="input-group-addon-email"
                                                                            style="font-size: 20px;padding-top:4px">@</span>
                                                                        <div class="input-group-append-email"
                                                                            style="margin-left: 0px !important;margin-top: 1px;">
                                                                            <v-select
                                                                                class="vselect-custom email-select new-select-tag email-select-admin"
                                                                                @change="checkPrimaryEmail"
                                                                                v-model="selecteddomainname"
                                                                                :options="domains"
                                                                                :searchable="publicDomain == true"
                                                                                @search="searchDomains"
                                                                                name="select_domain"
                                                                                v-validate="'required'"
                                                                                placeholder="Select Domain Name"
                                                                                data-vv-scope="newEmployee"
                                                                                data-vv-as="Domain Name"
                                                                                style="width: 200px;">
                                                                                <span slot="no-options">Please add
                                                                                    Domain Name</span>
                                                                            </v-select>
                                                                        </div>
                                                                    </div>
                                                                    <!-- <span class="input-group-addon"
                                                                            style="margin-top: 2px;font-size: 20px;cursor: pointer;position:absolute;right:0;top:0"
                                                                            v-if="!company_details.email.length"
                                                                            @click="customEmail()">
                                                                            <i class="icon-plus-circle-outline"
                                                                                style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                  </span>-->
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        style="text-transform: none !important;"
                                                                        v-show="errors.has('companyData.primary_email')">{{errors.first('companyData.primary_email')}}</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        style="text-transform: none !important;"
                                                                        v-show="errors.has('companyData.select_domain')">{{errors.first('companyData.select_domain')}}</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        style="text-transform: none !important;"
                                                                        v-show="primaryEmailExists">Email Already
                                                                        Exists</span>
                                                                </div>
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5"
                                                                    v-for="(mail, index) in company_details.email"
                                                                    :key="index">
                                                                    <div class="form-group">
                                                                        <input class="inputFieldNew new-text-box"
                                                                            :maxlength="maxlengthcompanyotheremails"
                                                                            v-validate="{regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/}"
                                                                            v-model="company_details.email[index].email_id"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as=" Email" type="text"
                                                                            :name="'email'+index.toString()"
                                                                            placeholder="Enter Email"
                                                                            style="border:solid 1px #676767 !important;" />
                                                                        <span class="inputBorder"></span>
                                                                        <label
                                                                            class="inputLabel text-secondary fs-14 fw-600">
                                                                            Alternate Email - {{index+1}}
                                                                        </label>
                                                                        <span class="input-group-addon removeBlocks"
                                                                            :class="{removedAdd: index+1!=company_details.email.length}"
                                                                            style="cursor: pointer;position: absolute;top: 0;text-align: right;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                                            @click="company_details.email.splice(index,1)">
                                                                            <i class="icon-minus-circle-outline"
                                                                                style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                        </span>
                                                                        <span class="input-group-addon"
                                                                            style="cursor: pointer;position: absolute;top: 0;text-align: right;right: 0px;margin-right:2px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                                            @click="customEmail()"
                                                                            v-if="index+1==company_details.email.length">
                                                                            <i class="icon-plus-circle-outline"
                                                                                style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                        </span>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('companyData.email'+index.toString())">{{errors.first('companyData.email'+index.toString())}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5"
                                                                    v-if="company_details.email&&company_details.email.length!=0&&company_details.email.length%2==0">
                                                                </div>
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5 mt-2">
                                                                    <div class="mt-2">
                                                                        <span
                                                                            class="text-secondary whiteSpace fs-14 fw-600">Primary
                                                                            Phone Number</span>
                                                                        <vue-tel-input
                                                                            class="teleContactborderedDark mt-2"
                                                                            name="phone_number"
                                                                            v-model="company_details.primary_phone.phone_number"
                                                                            v-on:country-changed="countryChanged($event, 'primary', 0)"
                                                                            ref="telInput"
                                                                            placeholder="Enter Phone Number"
                                                                            :disabledFormatting="false"
                                                                            :valid-characters-only="true"
                                                                            v-validate="{min:13}"
                                                                            :maxLen="maxPhoneLength"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as="Phone Number" autocomplete="off"
                                                                            >
                                                                        </vue-tel-input>
                                                                        <span class="input-group-addon"
                                                                            style="cursor: pointer;position: absolute;top: 0;text-align: right;right: 0px;margin-right:20px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;"
                                                                            @click="customPhone()"
                                                                            v-if="!company_details.phone_details.length">
                                                                            <i class="icon-plus-circle-outline"
                                                                                style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                        </span>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('companyData.phone_number')">Please
                                                                            Enter a Valid Phone Number</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5"
                                                                    v-if="company_details.email&&company_details.email.length!=0&&company_details.email.length%2==0">
                                                                </div>
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5"
                                                                    v-for="(phone, index) in company_details.phone_details"
                                                                    :key="index">
                                                                    <div class="mt-2">
                                                                        <span
                                                                            class="text-secondary whiteSpace fs-14 fw-600">
                                                                            Alternate Phone Number - {{index+1}}
                                                                        </span>
                                                                        <vue-tel-input
                                                                            class="teleContactborderedDark mt-2"
                                                                            :name="'phone_number'+index.toString()"
                                                                            v-model="company_details.phone_details[index].phone_number"
                                                                            v-on:country-changed="countryChanged($event, 'alternate', index)"
                                                                            ref="telInput"
                                                                            placeholder="Enter Phone Number"
                                                                            :disabledFormatting="false"
                                                                            :valid-characters-only="true"
                                                                            v-validate="{min:13}"
                                                                            :maxLen="maxPhoneLength"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as="Phone Number" autocomplete="off"
                                                                            @onInput="onInput1"
                                                                            >
                                                                        </vue-tel-input>
                                                                        <span
                                                                            class="input-group-addon removeBlocksPhone"
                                                                            :class="{removedAddPhone: index+1!=company_details.phone_details.length}"
                                                                            style="cursor: pointer;position: absolute;top: 0;margin-right:18px;text-align: right;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;"
                                                                            @click="company_details.phone_details.splice(index,1)">
                                                                            <i class="icon-minus-circle-outline"
                                                                                style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                        </span>
                                                                        <span class="input-group-addon"
                                                                            style="cursor: pointer;position: absolute;top: 0;text-align: right;right: 0px;margin-right:17px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;"
                                                                            @click="customPhone()"
                                                                            v-if="index+1==company_details.phone_details.length">
                                                                            <i class="icon-plus-circle-outline"
                                                                                style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                        </span>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('companyData.phone_number'+index.toString())">Please
                                                                            Enter a Valid Phone Number</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="block-company mt-4"
                                                        v-for="(branch, index) in company_details.branches"
                                                        :key="index">
                                                        <div class="infoHeaderHideShow mt-3 mb-3"
                                                            @click="expandBranch(index)">
                                                            <div class="descriptionheaderSetup"
                                                                style="background: transparent">
                                                                <div class="description-text-header-left"
                                                                    style="color: #303031">
                                                                    <h5 class="font-weight-bold text-dark whiteSpace">
                                                                        Branch {{index+1}}</h5>
                                                                </div>
                                                                <div class="description-text-header-right">
                                                                    <span class="collapse-addon"
                                                                        @click="expandBranch(index)"></span>
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hideShow.svg"
                                                                        :class="{'iconRotate':showBranch.includes('branch'+index)}"
                                                                        style="width: 23px !important;bottom:12px !important"
                                                                        class="rotateIcon" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="showBranch.includes('branch'+index)">
                                                            <div>
                                                                <div class="row">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                @blur="checkBranchExists"
                                                                                :name="'branch_code'+index.toString()"
                                                                                data-vv-scope="companyData"
                                                                                :maxlength="maxlengthbranchcode"
                                                                                data-vv-as="Branch Code"
                                                                                v-model="branch.code" type="text"
                                                                                placeholder="Enter Branch Code" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">Branch
                                                                                Code</label>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.branch_code'+index.toString())">{{errors.first('companyData.branch_code'+index.toString())}}</span>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-if="branchCodeDuplicates.includes(branch.code)">
                                                                                This
                                                                                Branch Code Is
                                                                                already Entered
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="form-group">
                                                                            <input type="text"
                                                                                class="inputFieldNew new-text-box"
                                                                                v-model="branch.name"
                                                                                :name="'branch_name'+index.toString()"
                                                                                data-vv-scope="companyData"
                                                                                data-vv-as="CompanyPrimary Admin"
                                                                                v-validate="'required'"
                                                                                :maxlength="maxlengthbranchname"
                                                                                @input="addBranch($event)"
                                                                                autocomplete="off"
                                                                                placeholder="Enter Branch Name" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">
                                                                                Branch Name
                                                                                <sup
                                                                                    class="fs-14 ml-02 mandatory">*</sup>
                                                                            </label>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.branch_name'+index.toString())">
                                                                                Branch
                                                                                Name Is
                                                                                required
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="form-group">
                                                                            <input type="text"
                                                                                class="inputFieldNew new-text-box"
                                                                                :name="'branch_department'+index.toString()"
                                                                                data-vv-scope="companyData"
                                                                                data-vv-as="CompanyPrimary Department"
                                                                                v-model="branch.department"
                                                                                @change="addDepartment(index)"
                                                                                v-validate="'required'"
                                                                                :maxlength="maxlengthdepartmentname"
                                                                                autocomplete="off"
                                                                                placeholder="Enter Department Name" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">
                                                                                Department
                                                                                <sup
                                                                                    class="fs-14 ml-02 mandatory">*</sup>
                                                                            </label>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.branch_department'+index.toString())">
                                                                                Department
                                                                                Is required
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h6 class="mt-7 font-weight-bold fs-14">
                                                                    Branch Communication Information
                                                                </h6>
                                                                <div class="row">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5 mt-5">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                v-model="branch.primary_email"
                                                                                :maxlength="maxlengthcompanyprimaryemail"
                                                                                type="text"
                                                                                :name="'branch_email'+index.toString()"
                                                                                data-vv-scope="companyData"
                                                                                data-vv-as="Branch Email"
                                                                                v-validate="'email'" autocomplete="off"
                                                                                placeholder="Enter Email" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">Branch
                                                                                Email</label>
                                                                            <span class="input-group-addon"
                                                                                style="cursor: pointer;position: absolute;top: 10px;text-align: right;right: 0px;margin-right:2px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                                                @click="BranchCustomEmail(index)"
                                                                                v-if="!branch.email.length">
                                                                                <i class="icon-plus-circle-outline"
                                                                                    style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                            </span>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.branch_email'+index.toString())">{{errors.first('companyData.branch_email'+index.toString())}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5"
                                                                        v-for="(mail, branch_index) in branch.email"
                                                                        :key="branch_index">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                v-validate="'email'"
                                                                                :maxlength="maxlengthcompanyotheremails"
                                                                                v-model="branch.email[branch_index].email_id"
                                                                                data-vv-scope="companyData"
                                                                                data-vv-as=" Email" type="text"
                                                                                :name="'email'+branch_index.toString()"
                                                                                placeholder="Enter Email" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">
                                                                                Alternate Email - {{branch_index+1}}
                                                                            </label>
                                                                            <span class="input-group-addon removeBlocks"
                                                                                :class="{removedAdd: branch_index+1!=branch.email.length}"
                                                                                style="cursor: pointer;position: absolute;top: 10px;text-align: right;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                                                @click="branch.email.splice(branch_index,1)">
                                                                                <i class="icon-minus-circle-outline"
                                                                                    style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                            </span>
                                                                            <span class="input-group-addon"
                                                                                style="cursor: pointer;position: absolute;top: 10px;text-align: right;right: 0;margin-right:2px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;"
                                                                                @click="BranchCustomEmail(index)"
                                                                                v-if="branch_index+1==branch.email.length">
                                                                                <i class="icon-plus-circle-outline"
                                                                                    style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                            </span>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.email'+branch_index.toString())">{{errors.first('companyData.email'+branch_index.toString())}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5"
                                                                        v-if="branch.email && branch.email.length!=0&&branch.email.length%2==0">
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="mt-2">
                                                                            <span
                                                                                class="text-secondary whiteSpace fs-14 fw-600">Branch
                                                                                Phone Number</span>
                                                                            <vue-tel-input
                                                                                class="teleContactborderedDark mt-2"
                                                                                :name="'phone_number'+index.toString()"
                                                                                v-model="branch.primary_phone.phone_number"
                                                                                v-on:country-changed="countryChanged($event, 'branch_primary', 0)"
                                                                                ref="telInput"
                                                                                placeholder="Enter Phone Number"
                                                                                :disabledFormatting="false"
                                                                                :valid-characters-only="true"
                                                                                v-validate="{min:13}"
                                                                                :maxLen="maxPhoneLength"
                                                                                data-vv-scope="companyData"
                                                                                data-vv-as="Phone Number"
                                                                                autocomplete="off"
                                                                                >
                                                                            </vue-tel-input>
                                                                            <span class="input-group-addon"
                                                                                style="cursor: pointer;position: absolute;top: 10px;text-align: right;right: 0px;margin-right:20px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;"
                                                                                @click="BranchCustomPhone(index)"
                                                                                v-if="!branch.phone_details.length">
                                                                                <i class="icon-plus-circle-outline"
                                                                                    style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                            </span>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                style="position:absolute !important"
                                                                                v-show="errors.has('companyData.phone_number'+index.toString())">
                                                                                Please
                                                                                Enter a
                                                                                Valid Phone Number
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5"
                                                                        v-for="(phone, branch_index) in branch.phone_details"
                                                                        :key="branch_index">
                                                                        <div class="mt-2">
                                                                            <span
                                                                                class="text-secondary whiteSpace fs-14 fw-600">
                                                                                Alternate Phone Number -
                                                                                {{branch_index+1}}
                                                                            </span>
                                                                            <vue-tel-input
                                                                                class="teleContactbordered mt-2"
                                                                                :name="'phone_number'+branch_index.toString()"
                                                                                v-model="branch.phone_details[branch_index].phone_number"
                                                                                v-on:country-changed="countryChanged($event, 'branch_alt', index)"
                                                                                ref="telInput"
                                                                                placeholder="Enter Phone Number"
                                                                                :disabledFormatting="false"
                                                                                :valid-characters-only="true"
                                                                                v-validate="{min:15}"
                                                                                :maxLen="maxPhoneLength"
                                                                                data-vv-scope="companyData"
                                                                                data-vv-as="Phone Number"
                                                                                autocomplete="off" @onInput="onInput"
                                                                                >
                                                                            </vue-tel-input>

                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-if="!validPhone">
                                                                                Phone Number Is
                                                                                Invalid
                                                                            </span>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-if="!branch.phone_details[branch_index].phone_number.length && saveClicked">
                                                                                Phone Number Field Is required
                                                                            </span>
                                                                            <span
                                                                                class="input-group-addon removeBlocksPhone"
                                                                                :class="{removedAddPhone: branch_index+1!=branch.phone_details.length}"
                                                                                style="cursor: pointer;position: absolute;top: 10px;margin-right:18px;text-align: right;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;"
                                                                                @click="branch.phone_details.splice(branch_index,1)">
                                                                                <i class="icon-minus-circle-outline"
                                                                                    style="color: #e82828;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                            </span>
                                                                            <span class="input-group-addon"
                                                                                style="cursor: pointer;position: absolute;top: 10px;text-align: right;right: 0px;margin-right:17px;border-radius: 0px !important;box-shadow: none !important;padding: 0px 0px !important;height: 28px;line-height: 28px;"
                                                                                @click="BranchCustomPhone(index)"
                                                                                v-if="branch_index+1==branch.phone_details.length">
                                                                                <i class="icon-plus-circle-outline"
                                                                                    style="color: #00448b;font-size: 16px;width: 18px;height: 18px;line-height: 18px;"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                :name="'branchWebsite'+index.toString()"
                                                                                data-vv-scope="companyData"
                                                                                data-vv-as="Branch Website"
                                                                                @change="getDomainNames"
                                                                                v-validate="{regex:/^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/}"
                                                                                v-model="branch.website" type="text"
                                                                                placeholder="Enter Website" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">Website</label>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-if="!domainValid">
                                                                                Please Enter
                                                                                Valid Domain Name
                                                                            </span>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.branchWebsite'+index.toString())">{{errors.first('companyData.branchWebsite'+index.toString())}}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <h6 class="mt-7 font-weight-bold fs-14">Branch Address
                                                                </h6>
                                                                <div class="row">
                                                                    <div
                                                                        class="col-lg-6 d-flex flex-row align-items-center mt-5">
                                                                        <span class="mr-4"
                                                                            style="color: #303031">Address Type :</span>
                                                                        <div class="preview-elements">
                                                                            <div
                                                                                class="form-check form-check-inline user-perm">
                                                                                <label
                                                                                    class="form-check-label check-label-dc"
                                                                                    style="width: 80px !important;">
                                                                                    <input class="form-check-input"
                                                                                        type="radio" value="Office"
                                                                                        v-model="branch.address.address_type" />
                                                                                    <span class="radio-icon"></span>
                                                                                    <span
                                                                                        class="form-check-description fw-600">Office</span>
                                                                                </label>
                                                                            </div>
                                                                            <div
                                                                                class="form-check form-check-inline user-perm">
                                                                                <label
                                                                                    class="form-check-label check-label-dc">
                                                                                    <input class="form-check-input"
                                                                                        type="radio" value="Factory"
                                                                                        v-model="branch.address.address_type" />
                                                                                    <span class="radio-icon"></span>
                                                                                    <span
                                                                                        class="form-check-description fw-600">Factory</span>
                                                                                </label>
                                                                            </div>
                                                                            <div
                                                                                class="form-check form-check-inline user-perm">
                                                                                <label
                                                                                    class="form-check-label check-label-dc">
                                                                                    <input class="form-check-input"
                                                                                        type="radio" value="Others"
                                                                                        v-model="branch.address.address_type" />
                                                                                    <span class="radio-icon"></span>
                                                                                    <span
                                                                                        class="form-check-description fw-600">Others</span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <div class="form-group pt-2 gMap"
                                                                            style="position:relative">
                                                                            <gmap-autocomplete
                                                                                class="inputFieldNew new-text-box"
                                                                                id="autocompleteInput"
                                                                                name="get_location"
                                                                                @place_changed="setPlace($event,index)"
                                                                                v-model="branch.address.meeting_location_vmodel"
                                                                                :value="branch.address.meeting_location_vmodel"
                                                                                placeholder="Enter Location">
                                                                            </gmap-autocomplete>
                                                                            <!-- <gmap-autocomplete
                                        class="inputFieldNew"
                                        id="autocompleteInput"
                                        name="get_location"
                                        v-validate="'required'"
                                        placeholder="Enter Address"
                                        @place_changed="setPlace($event,index)"
                                        :value="branch.address.meeting_location_vmodel"
                                        v-model="branch.address.meeting_location_vmodel"
                                        style="padding: 8px 32px 8px 12px !important;"
                                      ></gmap-autocomplete> -->
                                                                            <img src="/static/images/images-new-theme/icons/marker_pin.svg"
                                                                                style="position: absolute;right: 12px;bottom: 10px;" />
                                                                        </div>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('get_location')">Meeting
                                                                            Location Is Required</span>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                type="text" data-vv-scope="companyData"
                                                                                v-model="branch.address.building_number"
                                                                                data-vv-as="Branch Building Number"
                                                                                :name="'branch_building_number'+index.toString()"
                                                                                placeholder="Enter Building Number" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">Building
                                                                                No</label>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.branch_building_number'+index.toString())">{{errors.first('companyData.branch_building_number'+index.toString())}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                type="text" data-vv-scope="companyData"
                                                                                v-model="branch.address.street"
                                                                                :maxlength="maxlengthbranchstreet"
                                                                                data-vv-as="Branch Street"
                                                                                :name="'branch_street'+index.toString()"
                                                                                placeholder="Enter Street 1"
                                                                                oninput="this.value = this.value.toUpperCase()" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">Street
                                                                                1</label>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.branch_street'+index.toString())">{{errors.first('companyData.branch_street'+index.toString())}}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                type="text" data-vv-scope="companyData"
                                                                                v-model="branch.address.street2"
                                                                                :maxlength="maxlengthbranchstreet"
                                                                                data-vv-as="Branch Street2"
                                                                                :name="'branch_street2'+index.toString()"
                                                                                placeholder="Enter Street 2"
                                                                                oninput="this.value = this.value.toUpperCase()" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">Street
                                                                                2</label>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.branch_street2'+index.toString())">{{errors.first('companyData.branch_street2'+index.toString())}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                type="text"
                                                                                onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || (event.charCode == 32)"
                                                                                :maxlength="maxlengthbranchcity"
                                                                                :name="'branch_city'+index.toString()"
                                                                                data-vv-as="Branch City"
                                                                                data-vv-scope="companyData"
                                                                                v-model="branch.address.city"
                                                                                placeholder="Enter City"
                                                                                oninput="this.value = this.value.toUpperCase()" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">City</label>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.branch_city'+index.toString())">{{errors.first('companyData.branch_city'+index.toString())}}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                type="text"
                                                                                onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || (event.charCode == 32)"
                                                                                data-vv-as="Branch Township"
                                                                                :name="'branch_township'+index.toString()"
                                                                                data-vv-scope="companyData"
                                                                                :maxlength="maxlengthbranchtownship"
                                                                                v-model="branch.address.township"
                                                                                placeholder="Enter Township"
                                                                                oninput="this.value = this.value.toUpperCase()" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">Township</label>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.branch_township'+index.toString())">{{errors.first('companyData.branch_township'+index.toString())}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                type="text"
                                                                                onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || (event.charCode == 32)"
                                                                                data-vv-as="Branch State"
                                                                                :name="'branch_state'+index.toString()"
                                                                                placeholder="Enter State"
                                                                                data-vv-scope="companyData"
                                                                                :maxlength="maxlengthbranchstate"
                                                                                v-model="branch.address.state"
                                                                                oninput="this.value = this.value.toUpperCase()" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">State</label>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.branch_state'+index.toString())">{{errors.first('companyData.branch_state'+index.toString())}}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                type="text"
                                                                                :maxlength="maxlengthbranchzip_code"
                                                                                onkeypress="return /[a-zA-Z0-9]/i.test(event.key)"
                                                                                :name="'branch_pin_code'+index.toString()"
                                                                                data-vv-as="Branch Zip Code"
                                                                                placeholder="Enter Zip Code"
                                                                                data-vv-scope="companyData"
                                                                                v-model="branch.address.zip_code" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">Zip
                                                                                Code</label>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.branch_pin_code'+index.toString())">{{errors.first('companyData.branch_pin_code'+index.toString())}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="pt-2">
                                                                            <span
                                                                                class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                                Country
                                                                                <sup
                                                                                    class="fs-14 ml-02 mandatory">*</sup>
                                                                            </span>
                                                                            <multiselect
                                                                                class="diginew-multiselect digicompany-multiselect digidark-multiselect loaderdark no-default-icon down-arrow comanyTimeSelect"
                                                                                placeholder="Select Country"
                                                                                :clearable="false" :filterable="true"
                                                                                :options="countriesCaps"
                                                                                @input="branch.address.state = '',branch.address.city = '',branch.address.township = '',branch.address.zip_code = '',branch.address.meeting_location_vmodel = '',branch.address.building_number = '',branch.address.street = '',branch.address.street2 = ''"
                                                                                style="margin-top: 5px;"
                                                                                data-vv-scope="companyData"
                                                                                v-validate="'required'"
                                                                                v-model="branch.address.country"
                                                                                data-vv-as="Branch Country"
                                                                                :name="'branch_country'+index.toString()">
                                                                                <template slot="noOptions">
                                                                                    <div class="text-secondary text-center fw-600">Country Is Not Found</div>
                                                                                </template>
                                                                                <template slot="noResult">
                                                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                                                </template>
                                                                            </multiselect>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('companyData.branch_country'+index.toString())">Branch
                                                                                Country Is Required</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                type="text"
                                                                                placeholder="Enter Longitude"
                                                                                v-model="branch.address.latitude"
                                                                                hidden />
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                type="text"
                                                                                placeholder="Enter Longitude"
                                                                                v-model="branch.address.longitude"
                                                                                hidden />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew new-text-box"
                                                                                type="text"
                                                                                :maxlength="maxlengthbranchlocation"
                                                                                v-validate="'url'"
                                                                                :name="'location_url'+index.toString()"
                                                                                data-vv-as="Branch Location URL"
                                                                                data-vv-scope="companyData"
                                                                                v-model="branch.google_maps_url"
                                                                                placeholder="Enter Location URL" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel text-secondary fs-14 fw-600">Location
                                                                                URL</label>
                                                                        </div>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            v-show="errors.has('companyData.location_url'+index.toString())">{{errors.first('companyData.location_url'+index.toString())}}</span>
                                                                    </div>
                                                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                        <div class="d-flex justify-content-end align-items-end"
                                                                            style="height:100%">
                                                                            <button type="button"
                                                                                class="btn btn-new-primary btn-smm mr-2"
                                                                                style="box-shadow: none;"
                                                                                v-if="index+1==company_details.branches.length"
                                                                                @click="company_details.branches.push(JSON.parse(JSON.stringify(branchData))) && showBranch.push('branch'+(index+1))">
                                                                                +
                                                                                Add Branch
                                                                            </button>
                                                                            <button type="button"
                                                                                class="btn btn-new-danger btn-smm mr-2"
                                                                                style="box-shadow: none;background-color:#e82828 !important"
                                                                                v-if="index!=0"
                                                                                @click="company_details.branches.splice(index, 1) && showBranch.filter(x => { if (x !== 'branch'+index) { return x } })">
                                                                                Delete
                                                                                Branch
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="block-company mt-4">
                                                        <div class="infoHeaderHideShow mt-3 mb-3"
                                                            @click="expandAdminInfo()">
                                                            <div class="descriptionheaderSetup"
                                                                style="background: transparent">
                                                                <div class="description-text-header-left"
                                                                    style="color: #303031">
                                                                    <h5 class="font-weight-bold text-dark whiteSpace">
                                                                        Admin Information</h5>
                                                                </div>
                                                                <div class="description-text-header-right">
                                                                    <span class="collapse-addon"
                                                                        @click="expandAdminInfo()"></span>
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hideShow.svg"
                                                                        :class="{'iconRotate':showAdminInfo == true}"
                                                                        style="width: 23px !important;bottom:12px !important"
                                                                        class="rotateIcon" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="showAdminInfo == true">
                                                            <div class="row">
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                    <div class="form-group">
                                                                        <input type="text"
                                                                            class="inputFieldNew new-text-box"
                                                                            v-model="company_details.admin_details.full_name"
                                                                            name="admin_name"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as="CompanyPrimary Admin"
                                                                            v-validate="'required'" autocomplete="off"
                                                                            placeholder="Enter Admin Name"
                                                                            style="text-transform:capitalize" />
                                                                        <span class="inputBorder"></span>
                                                                        <label
                                                                            class="inputLabel text-secondary fs-14 fw-600">
                                                                            Admin Name
                                                                            <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                        </label>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            v-show="errors.has('companyData.admin_name')">
                                                                            Admin
                                                                            Name Is required
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-7">
                                                                    <span
                                                                        class="text-secondary whiteSpace fw-600 fs-14">
                                                                        Admin Email
                                                                        <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                    </span>
                                                                    <div class="email input-group mt-2">
                                                                        <input type="text"
                                                                            class="form-control-email-dropdown"
                                                                            v-model="selected_admin_email"
                                                                            name="admin_email"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as="CompanyPrimary Admin"
                                                                            @blur="checkAdminEmail"
                                                                            v-validate="{required: true,regex: /^[a-zA-Z0-9-_.]+$/}"
                                                                            autocomplete="off"
                                                                            placeholder="Enter Admin Email" />
                                                                        <span class="input-group-addon-email"
                                                                            style="font-size: 20px;padding-top:4px">@</span>
                                                                        <div class="input-group-append-email"
                                                                            style="margin-left: 0px !important;margin-top: 1px;">
                                                                            <v-select
                                                                                class="vselect-custom email-select new-select-tag email-select-admin"
                                                                                @change="checkAdminEmail"
                                                                                v-model="selected_admin_domain"
                                                                                :options="domains"
                                                                                :searchable="publicDomain == true"
                                                                                @search="searchDomains"
                                                                                name="select_admin_domain"
                                                                                v-validate="'required'"
                                                                                placeholder="Select Domain Name"
                                                                                data-vv-scope="newEmployee"
                                                                                data-vv-as="Domain Name"
                                                                                style="width: 200px;">
                                                                                <span slot="no-options">Please add
                                                                                    Domain Name</span>
                                                                            </v-select>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                style="text-transform: none !important;"
                                                                                v-show="errors.has('companyData.select_admin_domain')">{{errors.first('companyData.select_admin_domain')}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        v-show="errors.has('companyData.admin_email')">{{errors.first('companyData.admin_email')}}</span>
                                                                    <span class="invalid-feedback-form text-danger"
                                                                        style="text-transform: none !important;"
                                                                        v-show="adminEmailExists">Email Already
                                                                        Exists</span>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                    <div class="pt-2">
                                                                        <span
                                                                            class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                            Branch Name
                                                                            <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                        </span>
                                                                        <v-select
                                                                            v-if="company_details.branches[0].name"
                                                                            class="vselect-custom newborder new-select"
                                                                            placeholder="Select Branch Name"
                                                                            :clearable="false" :filterable="true"
                                                                            @change="showDepartments"
                                                                            :options="company_branches"
                                                                            v-model="company_details.admin_details.branch"
                                                                            style="width: 100%;margin-top: 7px;"
                                                                            v-validate="'required'"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as="Branch Name"
                                                                            name="admin_branch_name"></v-select>
                                                                        <v-select v-else
                                                                            class="vselect-custom newborder new-select"
                                                                            placeholder="Select Branch Name"
                                                                            :clearable="false" :filterable="true"
                                                                            @change="showDepartments"
                                                                            :options="['Please Create Branch']"
                                                                            v-model="company_details.admin_details.branch"
                                                                            style="width: 100%;margin-top: 7px;"
                                                                            v-validate="'required'"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as="Branch Name"
                                                                            name="admin_branch_name"></v-select>
                                                                        <span class="inputBorder"></span>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('companyData.admin_branch_name')">
                                                                            Branch
                                                                            Name Is
                                                                            Required
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                    <div class="pt-2">
                                                                        <span
                                                                            class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                            Department
                                                                            <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                        </span>
                                                                        <v-select
                                                                            v-if="company_details.admin_details.branch"
                                                                            class="vselect-custom newborder new-select"
                                                                            placeholder="Select Department"
                                                                            :clearable="false" :filterable="true"
                                                                            :options="departments"
                                                                            v-model="company_details.admin_details.department"
                                                                            style="width: 100%;margin-top: 7px;"
                                                                            v-validate="'required'"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as="Departments"
                                                                            name="admin_branch_department"></v-select>
                                                                        <v-select v-else
                                                                            class="vselect-custom newborder new-select"
                                                                            placeholder="Select Department"
                                                                            :clearable="false" :filterable="true"
                                                                            :options="['Please Select Admin Branch']"
                                                                            v-model="company_details.admin_details.department"
                                                                            style="width: 100%;margin-top: 7px;"
                                                                            v-validate="'required'"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as="Departments"
                                                                            name="admin_branch_department"></v-select>
                                                                        <span class="inputBorder"></span>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('companyData.admin_branch_department')">
                                                                            Department
                                                                            Is
                                                                            Required
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-lg-6 col-md-6 col-sm-12 mt-5">
                                                                    <div class="form-group">
                                                                        <input v-if="!showPassword" type="password"
                                                                            class="inputFieldNew new-text-box"
                                                                            v-model="company_details.admin_details.password"
                                                                            name="admin_password"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as="Admin Password"
                                                                            v-validate="{required:true,min:8,regex:/^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/}"
                                                                            placeholder="Enter Admin Password"
                                                                            autocomplete="new-password"
                                                                            oncopy="return false" onpaste="return false"
                                                                            oncut="return false" />
                                                                        <input v-else type="text"
                                                                            class="inputFieldNew new-text-box"
                                                                            v-model="company_details.admin_details.password"
                                                                            name="admin_password"
                                                                            data-vv-scope="companyData"
                                                                            data-vv-as="Admin Password"
                                                                            v-validate="{required:true,min:8,regex:/^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/}"
                                                                            placeholder="Enter Admin Password"
                                                                            autocomplete="new-password" />
                                                                        <span v-if="!showPassword"
                                                                            style="position: absolute; top: 45px; right: 5px; cursor: pointer;"
                                                                            @click="showPassword = !showPassword">
                                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg"
                                                                                alt="eye" style="width: 20px;">
                                                                        </span>
                                                                        <span v-else
                                                                            style="position: absolute; top: 45px; right: 5px; cursor: pointer;"
                                                                            @click="showPassword = !showPassword">
                                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg"
                                                                                alt="eye" style="width: 20px;">
                                                                        </span>
                                                                        <span class="inputBorder"></span>
                                                                        <label
                                                                            class="inputLabel text-secondary fs-14 fw-600">
                                                                            Password
                                                                            <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                        </label>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            v-show="errors.has('companyData.admin_password')">
                                                                            {{ errors.first('companyData.admin_password') }}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-12 text-center pt-8">
                                                            <button type="button"
                                                                class="btn btn-white btn-smm btn-no-border-blue ml-3"
                                                                style="color:#fff !important;background-color: #e82828; box-shadow: none !important;min-width: 5rem;"
                                                                @click="redirectToList">CANCEL</button>
                                                            <button v-if="!saveClicked" type="button"
                                                                @click="save_company_info()" class="btn btn-smm ml-3"
                                                                style="box-shadow: none;color:#fff;background-color:#448e4d">SAVE</button>
                                                            <button v-else type="button" class="btn btn-smm ml-3"
                                                                style="box-shadow: none;color:#fff;background-color:#448e4d;cursor:default;">SAVE</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import countries from "./json/countries.json";
    import bloodgroup from "./json/bloodgroup.json";
    import timezone from "./json/timezone.json";
    import currency from "./json/currency.json";
    import QrcodeVue from "qrcode.vue";
    import {
        company
    } from "./mixins/companySetup";
    import VueTelInput from "vue-tel-input";

    import VueTextareaAutosize from "vue-textarea-autosize";
    import axios from "axios";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    // import { LocationPicker } from "vue2-location-picker";
    // import  {see_location}  from "./mixins/location.js";
    // import { EventBus } from "./eventBus/nav-bar-event.js";
    const MAX_SIZE = 512000;
    export default {
        data() {
            return {
                selecteddomainname: "",
                phonenumber: "",
                mobilenumber: "",
                countries: countries,
                countriesCaps: [],
                bloodgroup: bloodgroup,
                companytype: [],
                timezone: timezone,
                currency: currency,
                branchphonenumber: "",
                alternatebranchphonenumber: "",
                homenumber: "",
                worknumber: "",
                emergencycontactnumber: "",
                mobilenumber: "",
                roomtype: "",
                pillowtype: "",
                bedtype: "",
                bedsheettype: "",
                valueqr: "https://example.com",
                size: 90,
                phonelabel: "",
                dob: "",
                focusInput: false,
                genderType: "",
                maxlengthcompanyname: 100,
                maxlengthemployees: 10,
                maxlengthcompanyabout: 1000,
                maxlengthcompanydomainname: 63,
                maxlengthcompanywebsite: 55,
                maxlengthcompanyprimaryemail: 230,
                maxlengthcompanyotheremails: 230,
                maxlengthcompanysocialmedia: 150,
                maxlengthbranchcode: 11,
                maxlengthbranchwebiste: 55,
                maxlengthbranchname: 40,
                maxlengthdepartmentname: 40,
                maxlengthbranchstreet: 80,
                maxlengthbranchcity: 20,
                maxlengthbranchtownship: 20,
                maxlengthbranchstate: 20,
                maxlengthbranchzip_code: 10,
                maxlengthbranchlocation: 2048,
                maxlengthPopup: 50,
                primaryemailPopover: false,
                othersemailPopover: false,
                primaryPhonePopover: false,
                othersphonePopover: false,
                branchprimaryemailPopover: false,
                branchothersemailPopover: false,
                branchprimaryphonePopover: false,
                branchothersphonePopover: false,
                userprimaryemailPopover: false,
                userothersemailPopover: false,
                userprimaryPhonePopover: false,
                userothersphonePopover: false,
                hidePasswordCompany: true,
                selected_admin_domain: "",
                selected_admin_email: "",
                selected_company_domain: "",
                hideConfirmPasswordCompany: true,
                validPhone: true,
                maxPhoneLength: 15,
                phone1: {
                    number: "",
                    isValid: false,
                    country: undefined,
                },
                minHeight: 10,
                maxHeight: 350,
                options: {
                    map: {},
                    marker: {
                        draggable: true,
                    },
                    autocomplete: {},
                },
                company_location: {
                    lat: 41.0082376,
                    lng: 28.97835889999999,
                },
                country: null,
                image: {
                    size: "",
                    // height:'',
                    // width:''
                },
                showInfo: true,
                showContactInfo: true,
                showSocial: true,
                showBranch: ["branch0"],
                showAdminInfo: true,
                facebook: "",
                twitter: "",
                linkedin: "",
                secondry_phone: "",
                fax: "",
                ajaxCallinprogress: false,
                showPassword: false,
                isLoading: {
                    industry_type: false,
                },
            };
        },
        mixins: [company],
        components: {
            QrcodeVue,
            // VueTelInput,
            VueTextareaAutosize,
            HalfCircleSpinner,
            // LocationPicker
        },
        methods: {
            // Sending Dial Code and Country Code
            showDepartments() {
                let index = this.company_details.branches.findIndex(
                    x => x.name === this.company_details.admin_details.branch
                );
                this.departments = this.company_details.branches[index].departments;
            },
            countryChanged(country, variable, index) {
                switch (variable) {
                    case "primary":
                        this.company_details.primary_phone.dial_code = country.dialCode;
                        this.company_details.primary_phone.country_code = country.iso2;
                        break;

                    case "alternate":
                        if (this.company_details.phone_details) {
                            this.company_details.phone_details[index].dial_code =
                                country.dialCode;
                            this.company_details.phone_details[index].country_code =
                                country.iso2;
                        }
                        break;

                    case "branch_primary":
                        this.company_details.branches[index].primary_phone.dial_code =
                            country.dialCode;
                        this.company_details.branches[index].primary_phone.country_code =
                            country.iso2;
                        break;

                    case "branch_alt":
                        if (this.company_details.branches.phone_details) {
                            this.company_details.branches.phone_details[index].dial_code =
                                country.dialCode;
                            this.company_details.branches.phone_details[index].country_code =
                                country.iso2;
                        }
                        break;
                }
            },
            onInput({
                number,
                isValid,
                country
            }) {
                this.validPhone = isValid;
            },
            onInput1({
                number,
                isValid,
                country
            }) {
                this.phone1.number = number;
                this.phone1.isValid = isValid;
                this.phone1.country = country;
            },
            isNumberKey(evt) {
                var charCode = evt.which ? evt.which : evt.keyCode;
                if (charCode > 31 && charCode != 46 && (charCode < 48 || charCode > 57))
                    return false;
                return true;
            },
            clearCustomValue(type) {
                if (type == "customEmailType") {
                    this.customEmailType = "";
                }
                if (type == "customPhoneType") {
                    this.customPhoneType = "";
                }
                if (type == "BranchCustomEmailType") {
                    this.BranchCustomEmailType = "";
                }
                if (type == "BranchCustomPhoneType") {
                    this.BranchCustomPhoneType = "";
                }
                if (type == "customUserEmailType") {
                    this.customUserEmailType = "";
                }
                if (type == "customUserPhoneType") {
                    this.customUserPhoneType = "";
                }
            },

            validateStep() {
                var inValid = false;
                return inValid;
            },
            saveCompanyDetails() {
                this.$validator.validateAll().then(result => {
                    if (result == true) {} else {
                        //this.$toasted.global.error('Please Fill All Required Fields');
                    }
                });
            },

            // Cover Picture Function
            onCompanyBackground(e) {
                var input = e.target;
                if (input.files && input.files[0]) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: "",
                    };
                    this.getResumableURL(input.files[0], attachment, "cover_pic");
                }
            },

            // Company Profile Pic(Logo) Function
            onCompanyProfile(e) {
                var input = e.target;
                if (input.files && input.files[0]) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: "",
                    };
                    this.getResumableURL(input.files[0], attachment, "profile_pic");
                }
            },
            getResumableURL(file, attachment, type) {
                let vuethis = this;
                let data = {
                    file: attachment.name,
                };
                data = new FormData();
                data.append("file", file);
                this.$http
                    .post("https://cloudapis.digicollect.com/external/upload_file", data)
                    .then(response => {
                        if (type == "profile_pic") {
                            vuethis.company_details.logo = response.data.url;
                            this.ajaxCallinprogress = false;
                            this.$awn.success("Uploaded Successfully");
                        } else if (type == "cover_pic") {
                            vuethis.company_details.cover_pic = response.data.url;
                            this.$awn.success("Uploaded Successfully");
                        }
                    })
                    .catch(error => {
                        // console.log(error.data.reason);
                        // this.error = "Error Uploading"
                    });
            },

            // Adding Social Media Function
            addMedia: function () {
                var media = document.getElementById("addInputMedia");
                this.socialMedia.push({
                    text: "",
                });
            },

            // Removing Social Media Function
            removeMedia: function (index) {
                this.socialMedia.splice(index, 1);
            },

            onlyNumber($event) {
                //console.log($event.keyCode); //keyCodes value
                let keyCode = $event.keyCode ? $event.keyCode : $event.which;
                if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                    // 46 is dot
                    $event.preventDefault();
                }
            },
            // selectTimezone(e) {
            //   this.company_details.time_zone = e.value;
            // },
            expandInfo() {
                if (!this.showInfo) {
                    this.showInfo = true;
                } else {
                    this.showInfo = false;
                }
            },
            expandContactInfo() {
                if (!this.showContactInfo) {
                    this.showContactInfo = true;
                } else {
                    this.showContactInfo = false;
                }
            },
            expandSocial() {
                if (!this.showSocial) {
                    this.showSocial = true;
                } else {
                    this.showSocial = false;
                }
            },
            expandBranch(index) {
                if (!this.showBranch.includes("branch" + index)) {
                    this.showBranch.push("branch" + index);
                } else {
                    this.showBranch = this.showBranch.filter(x => {
                        if (x !== "branch" + index) {
                            return x;
                        }
                    });
                }
            },
            expandAdminInfo() {
                if (!this.showAdminInfo) {
                    this.showAdminInfo = true;
                } else {
                    this.showAdminInfo = false;
                }
            },
            redirectToList() {
                this.$router.push({
                    name: "ManageCompany"
                });
            },
            setPlace(place, index) {
                let currentPlace = place;
                let address = place.formatted_address.split(", ");
                this.company_details.branches[index].address.street =
                    address[address.length - 3] || "";
                this.company_details.branches[index].address.state =
                    address[address.length - 2] || "";
                this.company_details.branches[index].address.township =
                    address[address.length - 4] || "";
                this.company_details.branches[index].address.city = currentPlace.vicinity;
                let statezip = address[address.length - 2] ?
                    address[address.length - 2].split(" ") :
                    ["", ""];
                this.company_details.branches[index].address.zip_code = statezip[0].match(/^[0-9]+$/) ?
                    statezip[0] :
                    statezip[1].match(/^[0-9]+$/) ?
                    statezip[1] :
                    "";
                this.company_details.branches[index].address.state = statezip[0].match(/^[a-zA-Z]+$/) ?
                    statezip[0] :
                    statezip[1].match(/^[a-zA-Z]+$/) ?
                    statezip[1] :
                    "";
                if (address[address.length - 1].includes("-")) {
                    let countrySelected = address[address.length - 1].split(" - ");
                    countrySelected.forEach(x => {
                        if (this.countries.includes(x)) {
                            this.company_details.branches[index].address.country = x;
                        } else {
                            this.company_details.branches[index].address.country = "";
                        }
                    });
                } else {
                    this.company_details.branches[index].address.country = address[address.length - 1];
                }
                this.company_details.branches[index].address.latitude = currentPlace.geometry.location.lat() || "";
                this.company_details.branches[index].address.longitude = currentPlace.geometry.location.lng() || "";
                this.company_details.branches[index].address.meeting_location_vmodel = place.formatted_address;
            },
            async getIndustries() {
                this.isLoading.industry_type = true;
                let res = await this.$http.get("/company/get_industry_type");
                if (res.data.status_id == 1) {
                    this.companytype = res.data.response.value;
                    this.isLoading.industry_type = false;
                }
            }
        },
        watch: {
            "company_details.company_domain"(newVal, oldVal) {
                this.getDomainNames();
            },

            // company_location(newVal){
            // 	see_location(this.company_location,this);
            // },
        },
        mounted() {
            let tz = new Date().getTimezoneOffset().toString();
            if (tz == "-330") {
                this.timeZone = {
                    label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi (Asia/Kolkata)",
                    value: "Asia/Kolkata",
                };
            } else if (tz == "-420") {
                this.timeZone = {
                    label: "(GMT+07:00) Bangkok, Hanoi, Jakarta (Asia/Bangkok)",
                    value: "Asia/Bangkok",
                };
            }
            this.countries.forEach(x => {
                this.countriesCaps.push(x.toUpperCase());
            });
        },
        computed: {
            passwordTypeCompany() {
                return this.hidePassword ? "password" : "text";
            },
            passwordIconCompany() {
                return this.hidePassword ? "icon-eye" : "icon-eye-off";
            },
            passwordConfirmTypeCompany() {
                return this.hideConfirmPassword ? "password" : "text";
            },
            passwordConfirmIconCompany() {
                return this.hideConfirmPassword ? "icon-eye" : "icon-eye-off";
            },
            company_branches() {
                return this.company_details.branches.map(branch => {
                    return branch.name;
                });
            },
        },
    };
</script>
<style>
    .company-create .vselect-custom.v-select.newborder .selected-tag {
        background: transparent !important;
    }

    .block-company {
        border-radius: 11px;
        box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
        background-color: rgba(255, 255, 255, 0.56);
        padding: 5px 15px 15px;
        margin-bottom: 22px;
    }

    .vue-form-wizard .wizard-tab-content {
        padding: 30px 0px 10px !important;
    }

    .vue-form-wizard .wizard-header {
        display: none !important;
    }

    .wizard-progress-bar {
        width: 88.8571% !important;
    }

    .vue-form-wizard .wizard-progress-bar {
        margin-left: 58px !important;
    }

    .vue-form-wizard .wizard-icon-circle.square_shape {
        border-radius: 13px !important;
    }

    .vue-form-wizard .wizard-icon-circle.square_shape {
        border-color: #f5f6f9 !important;
    }

    .vue-form-wizard .wizard-icon-circle.md.checked.square_shape {
        border-color: #00448b !important;
        background-color: #00448b !important;
    }

    .vue-form-wizard .wizard-icon-circle {
        border: 3px solid #d6e2ef !important;
        background-color: #d6e2ef !important;
    }

    .vue-form-wizard .wizard-icon-circle.md.checked .wizard-icon-container.square_shape,
    .vue-form-wizard .wizard-icon-circle.md.checked .wizard-icon-container.tab_shape {
        border-radius: 6px !important;
        background-color: transparent !important;
    }

    .vue-form-wizard .wizard-icon-circle .wizard-icon {
        color: #00448b !important;
        font-size: 36px;
        width: 36px;
        height: 64px;
        line-height: 64px;
    }

    .vue-form-wizard.md .wizard-nav-pills>li.active>a .wizard-icon {
        font-size: 36px;
        width: 36px;
        height: 64px;
        line-height: 64px;
    }

    .vue-form-wizard .wizard-icon-circle.md.checked .wizard-icon {
        color: #fff !important;
    }

    .vue-form-wizard .wizard-card-footer {
        position: absolute;
        margin-top: -70px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .vue-form-wizard .wizard-card-footer .wizard-footer-left {
        float: none !important;
    }

    .vue-form-wizard .wizard-card-footer .wizard-footer-right {
        float: none !important;
    }

    .vue-form-wizard .navbar .navbar-nav>li>a.wizard-btn,
    .vue-form-wizard .wizard-btn {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-width: 2px;
        background-color: transparent;
        font-size: 14px;
        font-weight: 600;
        padding: 6px 12px;
        min-width: 90px;
        height: 32px;
    }

    .vue-form-wizard .wizard-btn {
        display: inline-block;
        margin-bottom: 0;
        font-weight: 400;
        text-align: center;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        background-image: none;
        border: 1px solid transparent;
        white-space: nowrap;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857;
        border-radius: 18px !important;
    }

    .stepTitle {
        font-size: 14px;
        font-weight: 500;
        line-height: 1.21;
        letter-spacing: 0.6px;
        color: #303031;
        margin-top: 10px;
    }

    input[type="file"] {
        display: none;
    }

    .uploadCertificate .el-button--small {
        padding: 2px 20px 5px 10px !important;
        border-radius: 20px;
    }

    .fs-18 {
        font-size: 18px;
    }

    .saveProfile {
        width: 190px;
    }

    .selectPlaceholder {
        color: #cdd2da !important;
    }

    .form-group,
    .form-check.statuaryGroup {
        font-size: 1.6rem;
        will-change: auto !important;
        position: relative;
    }

    .companyPic {
        display: block;
        position: absolute;
        left: 8%;
        top: 150px;
    }

    .companyPicEdit {
        position: absolute;
        top: 65px;
        right: 2%;
        cursor: pointer;
    }

    .custom-background-upload {
        width: 166px;
        height: 32px;
        float: right;
        right: 25px;
        position: absolute;
        border: solid 1px rgba(0, 0, 0, 0.4);
        background-color: rgba(0, 0, 0, 0.2);
        color: #ffffff;
        border-radius: 50px;
        top: 188px;
    }

    .socialMedia.dropdown-toggle::after {
        margin-left: 5px;
    }

    @-moz-document url-prefix() {
        .inputMedia {
            padding-right: 26px !important;
        }
    }

    .mediaDropdown.dropdown-menu {
        margin: 0rem 0rem 0 !important;
    }

    .doccrm .example>.description {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 8px 12px;
        border-bottom: 1px solid transparent;
    }

    .doccrm .example>.description .description-text h5 {
        font-size: 14px;
        font-weight: 600;
        margin: 0;
    }

    .doccrm .example>.description .toggle-source-preview {
        cursor: pointer;
        font-family: inherit;
        font-size: 12px;
        margin-left: auto;
        padding-left: 24px;
        color: rgba(0, 0, 0, 0.54);
    }

    .doccrm .example {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        min-height: 0px;
        height: 100%;
        position: relative;
        opacity: 1;
        border-radius: 5px;
        background-color: rgba(13, 132, 242, 0.4);
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .doccrm .example>.description .description-text h5 {
        text-align: center;
        color: #303031 !important;
        font-size: 16px;
        font-weight: 600;
    }

    .qrcode-block {
        border-radius: 6px;
        border: solid 2px #00448b;
        background-color: #d6e2ef;
        width: 110px;
        height: 110px;
        position: relative;
        display: inline-block;
        white-space: nowrap;
        vertical-align: bottom;
    }

    .qrcode-content {
        text-align: center;
        margin: 7px auto;
    }

    .qr-logo {
        position: absolute;
        margin-top: 35px;
        margin-left: 40px;
        width: 30px;
    }

    .vue-phone-number-input.digiphone {
        font-family: "Poppins", sans-serif !important;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .field-input {
        background-color: transparent;
        position: relative;
        width: 100%;
        height: 34px;
        min-height: 34px;
        padding-right: 18px;
        padding-left: 0px;
        font-weight: 400;
        -webkit-appearance: none;
        outline: none;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #cdd2da !important;
        border-radius: 0px;
        font-size: 13px !important;
        z-index: 0;
        margin-top: 5px;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .country-selector-arrow {
        position: absolute;
        right: 0;
        top: calc(50% - 6px);
        width: 22px;
        color: #4e5764;
        -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
        font-size: 12px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        text-align: center;
        display: inline-block;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .field-country-flag {
        margin: auto 0;
        position: absolute;
        top: 17px;
        left: 2px;
        z-index: 1;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector.is-focused.has-value .field-input {
        padding-top: 0px;
        padding-left: 30px;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #00448b !important;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector.has-value .field-input {
        padding-top: 0px;
        padding-left: 30px;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #cdd2da !important;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector.has-hint .field-input {
        padding-top: 0px;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector.has-error .field-input {
        border-color: #ff4500 !important;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #ff4500 !important;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .field-label {
        position: absolute;
        top: 0px;
        left: 0px;
        -webkit-transform: translateY(25%);
        transform: translateY(25%);
        opacity: 0;
        font-size: 11px;
        color: #4e5764;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector.has-value .field-label {
        color: #00448b !important;
        opacity: 0;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui .field-input:not(.textarea) {
        height: 34px;
        min-height: 34px;
        margin-top: 5px;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui.is-focused.has-value .field-input {
        padding-top: 0px;
    }

    .vue-phone-number-input.digiphone .field.vue-input-ui.input-phone-number.is-focused input.field-input {
        border: 1px solid transparent !important;
        border-bottom: 1px solid #00448b !important;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui .field-input {
        cursor: pointer;
        background-color: #fff;
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
        position: relative;
        width: 100%;
        padding: 0 12px;
        font-weight: 400;
        -webkit-appearance: none;
        outline: none;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #cdd2da !important;
        border-radius: 0px;
        font-size: 13px !important;
        z-index: 0;
        color: #303031;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector.has-value .field-input {
        opacity: 1;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #cdd2da !important;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui .field-label {
        position: absolute;
        top: 0px;
        cursor: pointer;
        left: 13px;
        -webkit-transform: translateY(25%);
        transform: translateY(25%);
        opacity: 0;
        -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
        font-size: 11px;
        color: #4e5764;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui.has-value .field-label {
        opacity: 0;
        color: #00448b;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui .field-clear {
        position: absolute;
        top: 15px;
        bottom: 0;
        right: 8px;
        margin: auto 0;
        width: 24px;
        height: 24px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: none;
        background: transparent;
        color: #4e5764;
        border-radius: 24px;
        cursor: pointer;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui .field-clear:hover {
        color: #fff;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui.is-focused.has-value .field-input {
        border-color: transparent !important;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #00448b !important;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui.has-value .field-input {
        border-color: transparent !important;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #cdd2da !important;
    }

    .vue-phone-number-input.digiphone .flex-1 .field.vue-input-ui.is-focused.has-value input.field-input:not(.textarea) {
        border-color: transparent !important;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #cdd2da !important;
    }

    .vue-phone-number-input.digiphone .select-country-container {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 90px;
        flex: 0 0 90px;
        width: 90px;
        min-width: 90px;
        max-width: 90px;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .country-list-item .dots-text {
        color: #303031;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .country-list-item.selected .dots-text {
        color: #00448b;
        font-weight: 600;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .country-list-item.keyboard-selected,
    .vue-phone-number-input.digiphone .select-country-container .country-selector .country-list-item:hover {
        background-color: #f5f6f9;
    }

    .vue-phone-number-input.digiphone .select-country-container .country-selector .country-list {
        border-radius: 8px;
        -webkit-box-shadow: 3px 2px 20px rgba(0, 0, 0, 0.2) !important;
        box-shadow: 3px 2px 20px rgba(0, 0, 0, 0.2) !important;
    }

    .el-popper[x-placement^="right"] .popper__arrow {
        display: none;
    }

    .removeBlocks {
        right: 20px;
        margin-right: 2px;
    }

    .removeBlocks.removedAdd {
        right: 4px;
        margin-right: 2px;
    }

    .removeBlocksSocial {
        right: 18px;
        margin-right: 0px;
    }

    .removeBlocksSocial.removedAddSocial {
        right: 0px;
        margin-right: 4px !important;
    }

    .removeBlocksPhone {
        right: 18px;
        margin-right: 2px;
    }

    .removeBlocksPhone.removedAddPhone {
        right: 0px;
        margin-right: 2px;
    }

    .removeBlocksPhoneNew {
        right: 11px;
        margin-right: 8px;
    }

    .inputFieldNew.primaryEmail:focus~label,
    .inputFieldNew.primaryEmail:valid~label {
        top: 0px;
    }

    .cover-pic-create-company {
        background-size: cover;
        height: 250px;
    }

    .character-count-dark {
        margin: 0.8rem 0 0;
        opacity: 1;
        filter: alpha(opacity=100);
        font-size: 12px;
        display: block;
        float: right;
        color: #000000 !important;
    }

    .vue-input-tag-wrapper.digi-input-tags {
        border-bottom: 0 !important;
        border: 0.3px solid #0d5be6 !important;
        border-radius: 10px !important;
    }

    .newborder .dropdown-toggle {
        background: transparent !important;
        overflow: hidden;
    }

    .dateborderTransparent {
        background-color: transparent !important;
        margin-top: 5px;
    }

    .infoHeaderHideShow {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        min-height: 40px;
        position: relative;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 5px;
        line-height: 40px;
        cursor: pointer;
    }

    .infoHeaderHideShow>.descriptionheaderSetup {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 10px 0px;
        border-bottom: 1px solid transparent;
    }

    .infoHeaderHideShow>.descriptionheaderSetup .description-text-header-left h5 {
        font-size: 14px;
        font-weight: 600;
        margin: 0;
        color: #000000;
        width: max-content;
    }

    .infoHeaderHideShow>.descriptionheaderSetup .description-text-header-right {
        font-size: 13px;
        margin-left: auto;
        padding-left: 12px;
        color: #005dae;
        font-weight: 500;
    }

    .infoHeaderHideShow>.descriptionheaderSetup .description-text-header-right {
        display: block;
        border-bottom: 1px solid #b2b2b3;
        width: 100%;
        margin-left: 10px;
    }

    .infoHeaderHideShow>.descriptionheaderSetup .description-text-header-right i {
        color: #005dae;
        font-size: 16px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        cursor: pointer;
    }

    .infoHeaderHideShow>.descriptionheaderSetup .description-text-header-right img {
        float: right;
        color: #005dae;
        width: 28px;
        cursor: pointer;
        position: absolute;
        right: 0px;
        bottom: -15px;
    }

    .infoHeaderHideShow>.descriptionheaderSetup .description-text-header-right-small {
        font-size: 13px;
        margin-left: auto;
        padding-left: 12px;
        color: #005dae;
        font-weight: 500;
    }

    .infoHeaderHideShow>.descriptionheaderSetup .description-text-header-right-small {
        display: block;
        border-bottom: 1px solid #b2b2b3;
        width: 100%;
        margin-left: 10px;
    }

    .infoHeaderHideShow>.descriptionheaderSetup .description-text-header-right-small i {
        color: #005dae;
        font-size: 16px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        cursor: pointer;
    }

    .infoHeaderHideShow>.descriptionheaderSetup .description-text-header-right-small img {
        float: right;
        color: #005dae;
        width: 28px;
        cursor: pointer;
        position: absolute;
        right: 3px;
        bottom: -15px;
    }

    .rotateIcon {
        transform: rotate(180deg);
    }

    .iconRotate {
        transform: rotate(0deg) !important;
    }

    .mediaIcons {
        font-size: 2.5rem !important;
        margin-right: 5px;
        border: 1.3px solid #0d5be6;
        border-radius: 5px;
        width: 4rem;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .mediaInput {
        margin-left: 5px;
        margin-top: 0 !important;
    }

    .mediaGroup {
        display: grid;
        grid-template-columns: 1fr 11fr;
        align-items: center;
        padding-top: 0;
    }

    .multiselect.diginew-multiselect.comanyTimeSelect .multiselect__tags {
        background: transparent !important;
    }

    .multiselect.diginew-multiselect.comanyTimeSelect .multiselect__single {
        background: transparent !important;
    }

    .multiselect.diginew-multiselect.comanyTimeSelect .multiselect__input {
        background: transparent !important;
    }

    .form-control-email-dropdown {
        position: relative !important;
        -webkit-box-flex: 1 !important;
        -webkit-flex: 1 1 auto !important;
        -ms-flex: 1 1 auto !important;
        flex: 1 1 auto !important;
        width: 1% !important;
        margin-bottom: 0 !important;
        height: 34px !important;
        padding: 15px 12px 6px 8px !important;
        color: #303031;
        background-color: transparent !important;
    }

    .form-control-email-dropdown::placeholder {
        font-size: 14px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/SetUp.vue